import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "./modal.scss";

interface ModalComponentProps {
  isOpen: boolean;
  modalBody: any;
  toggle: () => void;
  btnLeftHandler: () => void;
  btnLeftLabel: string;
  btnRightLabel?: string;
  modalTitle: string;
}

const ModalComponent = ({
  isOpen,
  toggle,
  modalTitle,
  modalBody,
  btnLeftHandler,
  btnLeftLabel,
  btnRightLabel = "",
}: ModalComponentProps) => {
  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
        <ModalBody>{modalBody}</ModalBody>
        <ModalFooter>
          {btnLeftLabel === "" ? (
            null
          ) : (<Button color="primary" onClick={btnLeftHandler}>
            {btnLeftLabel}
          </Button>)}{" "}
          {btnRightLabel === "" ? (
            <div></div>
          ) : (
            <Button color="secondary" onClick={toggle}>
              {btnRightLabel}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalComponent;
